import { render } from "./announcements_page.vue?vue&type=template&id=5f7adce8"
import script from "./announcements_page.js?vue&type=script&lang=js&external"
export * from "./announcements_page.js?vue&type=script&lang=js&external"

import "./announcements_page.vue?vue&type=style&index=0&id=5f7adce8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__